import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const sweepTextVariants = cva(
  'text-sm font-medium animate-sweep bg-clip-text text-transparent [background-size:200%_auto]',
  {
    variants: {
      variant: {
        yellowfin: 'bg-sweep-yellowfin',
        dark: 'bg-sweep-dark',
        'dark-subtle': 'bg-sweep-dark-subtle [animation-duration:2.4s]',
      },
    },
    defaultVariants: {
      variant: 'yellowfin',
    },
  },
);

export type SweepTextVariant = NonNullable<VariantProps<typeof sweepTextVariants>['variant']>;

export interface SweepTextProps {
  className?: string;
  children?: React.ReactNode;
  variant?: SweepTextVariant;
}

/** Shimmer/sweep status text. The animated gradient sweeps across the text. */
export const SweepText = ({ className, children, variant }: SweepTextProps) => {
  return <span className={cn(sweepTextVariants({ variant }), className)}>{children}</span>;
};
